<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar usuarios</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de usuarios.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Tipo de usuario</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allRoles" name="allRoles" (change)="toggleAllRoles()">
            <span class="crm-checkbox-custom"></span>
            Todos los tipos
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.roles.administrador" name="administrador" (change)="onRoleChange()">
            <span class="crm-checkbox-custom"></span>
            Administrador
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.roles.ejecutivo" name="ejecutivo" (change)="onRoleChange()">
            <span class="crm-checkbox-custom"></span>
            Ejecutivo comercial
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.roles.otros" name="otros" (change)="onRoleChange()">
            <span class="crm-checkbox-custom"></span>
            Otros perfiles
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Estado del usuario</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allStatuses" name="allStatuses" (change)="toggleAllStatuses()">
            <span class="crm-checkbox-custom"></span>
            Todos los estados
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.activo" name="activo" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Activo
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.inactivo" name="inactivo" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Inactivo
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Último inicio de sesión</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="lastLogin" [(ngModel)]="filters.lastLogin" value="all">
            <span class="crm-radio-custom"></span>
            Todos
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="lastLogin" [(ngModel)]="filters.lastLogin" value="7d">
            <span class="crm-radio-custom"></span>
            Últimos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="lastLogin" [(ngModel)]="filters.lastLogin" value="30d">
            <span class="crm-radio-custom"></span>
            Últimos 30 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="lastLogin" [(ngModel)]="filters.lastLogin" value="never">
            <span class="crm-radio-custom"></span>
            Nunca han iniciado
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>